import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import ValidationIcon from './ValidationIcon';
import { ERROR_MESSAGE_IDS, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from '../../constants';
import { mapValidationsStatus } from '../../utils/validations';

function ValidationBox({ error, value }) {
  const validationStatuses = mapValidationsStatus(value);
  const validations = Object.entries(validationStatuses);

  const MESSAGE_IDS = {
    title: 'shopping.page.checkout.account.form.errors.title'
  };

  return (
    <Card color="default" role="alert" variant="contained">
      <CardContent component={Stack} spacing={1.5}>
        <Text size="xs" weight="medium">
          <FormattedMessage id={MESSAGE_IDS.title} />
        </Text>

        {validations.map(([validationKey, hasPassed]) => (
          <Stack
            key={validationKey}
            alignItems="center"
            as={Text}
            data-testid={`password-validation-${validationKey}`}
            direction="row"
            size="xs"
            spacing={1}
          >
            <ValidationIcon hasError={!!error} hasPassed={hasPassed} />
            <FormattedMessage
              id={ERROR_MESSAGE_IDS[validationKey]}
              values={{
                minLength: PASSWORD_MIN_LENGTH,
                maxLength: PASSWORD_MAX_LENGTH
              }}
            />
          </Stack>
        ))}
      </CardContent>
    </Card>
  );
}

ValidationBox.propTypes = {
  error: PropTypes.object,
  value: PropTypes.string
};

export default ValidationBox;
